import { createSlice , PayloadAction } from "@reduxjs/toolkit";

interface SchedulerState {
  scheduleCreateResponse: number;
  isScheduling: boolean;
  isScheduleModalOpen: boolean;
}

const initialState: SchedulerState = {
  scheduleCreateResponse: 0,
  isScheduling: false,
  isScheduleModalOpen: false,
};

export const schedulerSlice = createSlice({
  name: "scheduler",
  initialState,
  reducers: {
    setScheduleCreateResponse: (state: SchedulerState) => {
      state.scheduleCreateResponse = state.scheduleCreateResponse + 1;
    },
    setIsScheduling: (state, action: PayloadAction<boolean>) => {
      state.isScheduling = action.payload;
    },
    setIsScheduleModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isScheduleModalOpen = action.payload;
    },

  },
});

export const { setScheduleCreateResponse, setIsScheduling, setIsScheduleModalOpen } = schedulerSlice.actions;

export default schedulerSlice.reducer;
